/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Processing_JobInputs */



/**
* | output |
* | --- |
* | "Processing Job" |
*
* @param {Embed_Captions_Processing_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_processing_job = /** @type {((inputs?: Embed_Captions_Processing_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Processing_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Traitement de la tache")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verarbeitungsauftrag")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elaborazione del lavoro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обработка задания")
	if (locale === "es") return /** @type {LocalizedString} */ ("Trabajo de procesamiento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("处理作业")
	if (locale === "ja") return /** @type {LocalizedString} */ ("処理ジョブ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्य प्रक्रिया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tarefa de processamento")
	return /** @type {LocalizedString} */ ("Processing Job")
});